import React from 'react';

const EclairFooterCredit = () => {
  return (
    <p style={{ fontSize: '14px', color: '#999', margin: '0', textAlign: 'center' }}>
      Hecho con <span style={{ color: '#ff4444' }}>♥</span> por{' '}
      <a
        href="https://eclair.gg/t/oec"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: '#fff',
          textDecoration: 'none',
          transition: 'color 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.color = '#60A5FA'}
        onMouseLeave={(e) => e.target.style.color = '#fff'}
      >
        Eclair.site
      </a>
    </p>
  );
};

export default EclairFooterCredit;